import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CorrectionsDetailsTable from './content';
import useCorrectionsDetailsStyles from './styles';
const CorrectionsDetails = _ref => {
  let allocationCycleId = _ref.allocationCycleId;
  const classes = useCorrectionsDetailsStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    className: classes.alertButton,
    variant: "actionButton",
    'custom-attribute': '513-allocation-utility'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-on"
  }), t('corrections.view_details'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setIsOpen(false),
    handleOpen: () => setIsOpen(true),
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: t('corrections.previous_adjustment'),
    trigger: defaultTrigger,
    variant: 'large'
  }, /*#__PURE__*/React.createElement(CorrectionsDetailsTable, {
    allocationCycleId: allocationCycleId,
    setIsOpen: setIsOpen
  }));
};
export default CorrectionsDetails;